module.exports = __webpack_public_path__ + "static/media/super_reforzada.298e62db.jpg";